import {useEffect} from 'react'
import {useSelector} from '../../../../store.js'
import ButtonLink from '../../Button/ButtonLink.js'
import CommentGroup from './CommentGroup.js'

/**
 * A comment timeline in the sidebar
 *
 * @param {Object} props
 * @param {String} props.title
 * @param {Function} props.commentGroupsSelector
 * @param {Function} props.ensureComments
 * @param {Function} props.addComment
 * @param {Boolean} [props.readOnly]
 * @returns {React.ReactNode}
 */
export default function SidebarTimeline({
  title,
  readOnly,
  addComment,
  commentGroupsSelector,
  ensureComments,
}) {
  const commentGroups = useSelector(commentGroupsSelector)

  useEffect(() => {
    ensureComments()
  }, [commentGroups.length === 0])

  return (
    <dl className="list">
      <dt className="list__title--order-data">{title}</dt>
      <dd className="list__item--order-data">
        <ButtonLink
          className="fs-n0 meta-batchlist-button-add-comment"
          onClick={() => addComment()}
          disabled={readOnly}
        >
          Add a comment
        </ButtonLink>
      </dd>
      <dd>
        {commentGroups.length === 0 && (
          <div className="loading align-left margin-top-10 margin-bottom-20">
            <span className="spinner--md v-align-middle" />
            <em className="inline-block v-align-middle fs-n0 op-75 margin-left-5">
              Loading history...
            </em>
          </div>
        )}
        {commentGroups.map(({day, comments}) => (
          <CommentGroup key={day} day={day} comments={comments} />
        ))}
      </dd>
    </dl>
  )
}
